import { ConectoresDuplicacao } from '@containers';
import { InfoUsuario } from '@utils';

const getPermissaoFila = (infoUsuario) => InfoUsuario.perm('admin') || InfoUsuario.perm('fila');

export default [
  {
    path: '/conectores/configuracao/:idCliente/:id/duplicacao',
    text: 'Duplicação',
    exact: true,
    component: ConectoresDuplicacao,
    secret: true,
    permissions: (infoUsuario) => getPermissaoFila(infoUsuario),
  },
];
